import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=b7dc9524&scoped=true"
import script from "./BrandList.vue?vue&type=script&lang=js"
export * from "./BrandList.vue?vue&type=script&lang=js"
import style0 from "./BrandList.vue?vue&type=style&index=0&id=b7dc9524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dc9524",
  null
  
)

export default component.exports